// extracted by mini-css-extract-plugin
export default {"subtitle":"iiKgIb"};